import React from 'react';
import { ResidentialUnitListProps, ResidentialUnitViewMode } from '.';
import ResidentialUnitListItem from './ResidentialUnitListItem';
import { ResidentialExpandedListItem } from './ResidentialExpandedListItem';

const ResidentialUnitList: React.FC<ResidentialUnitListProps> = ({
    residentialUnits,
    viewMode = ResidentialUnitViewMode.Compressed,
    selectedUnitIds = [],
    onUnitSelect,
    ...rest
}) => {
    const Component = viewMode === ResidentialUnitViewMode.Expanded ? ResidentialExpandedListItem : ResidentialUnitListItem;

    return (
        <>
            {residentialUnits.map((residentialUnit) => (
                <Component
                    key={residentialUnit.id}
                    residentialUnit={residentialUnit}
                    selectedUnitIds={selectedUnitIds}
                    onUnitSelect={onUnitSelect}
                    {...rest}
                />
            ))}
        </>
    );
};

export default ResidentialUnitList;